var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type=='email')?_c('img',{staticClass:"img-box",attrs:{"src":require("../../assets/down/ydj-email.jpg")}}):(_vm.type=='pcydj')?_c('img',{staticClass:"img-box",attrs:{"src":require("../../assets/down/pc-ydj.jpg")}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }